import { isProUser } from "../utils/entitlements";

function Username({ username, profile, isPro, prefix = "@", style, ...props }) {
  const pro = typeof isPro === "boolean" ? isPro : isProUser(profile);
  return <span style={{ ...style, color: pro ? "#e10600" : style?.color }}>{prefix}{username}</span>;
}

export default Username;
